import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelfUser, getShops } from "../../../../services/auth/actions";
import { useHistory, useLocation } from "react-router";
import SelectTemplate from "../../screens/visual/SelectTemplate";
import HistoryButtons from "../../screens/visual/HistoryButtons";
import { useThemesContext } from "../../context/ThemeProvider";
import { toastAlert } from "@paylixecommerce/shared/components";
import { Spin2, Button } from 'components';
import { useChangesHistoryContext } from "../../screens/visual/context";
import ClosePage from "../../../dashboard/screens/products/product/screens/components/save-close";

import "./style.scss";

const CloseIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M13.5 4.5L4.5 13.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M4.5 4.5L13.5 13.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

const EyeIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M16.5 9C14.4997 12.5002 12 14.25 9 14.25C6 14.25 3.50025 12.5002 1.5 9C3.50025 5.49975 6 3.75 9 3.75C12 3.75 14.4997 5.49975 16.5 9Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


const Header = () => {

	const { selectedTheme, selectedTemplate, setSelectedTemplate, updateTheme, updateThemeLayout, updateThemeTemplate } = useThemesContext();
	const { currentStateIndex, currentState, clearHistory } = useChangesHistoryContext();
	const [isLoading, setIsLoading] = useState(false);
	const [closeConfirmModal, setShowConfirmModal] = useState(false);
	const [isAdmin] = useState(false);
	const dispatch = useDispatch();
	const history = useHistory();
	const { pathname } = useLocation();
	const isAuth = useSelector(({ auth }) => auth.isAuth);
	const userShop = useSelector(({ common, auth }) => {
		return (auth.profile || {})
	});

	let name = (userShop.username || "").toLowerCase();

	const MAIN_TEMPLATE_TYPE = 'MAIN';

	useEffect(() => {

		if(!isAuth) {
			dispatch(getSelfUser())
				.then(({ status, data }) => {
					if (status === 200) {
						dispatch(getShops(data.user.username));
						if (isAdmin && +data.user.rank < 1) {
							history.push(`/home`)
						}
					}
				})
		}

		if (!selectedTemplate) {
			const selected = Object
				.values(selectedTheme ? selectedTheme.templates : {})
				.find(({ is_default, template_type }) => !!is_default && template_type === MAIN_TEMPLATE_TYPE);
			setSelectedTemplate(selected);
		}
	}, [selectedTheme]);

	const handleSave = async () => {
		setIsLoading(true);

		await Promise.all([
			JSON.stringify(currentState.settings) !==
			JSON.stringify(selectedTheme.settings)
				? updateTheme(
					{
						...selectedTheme,
						settings: currentState.settings,
					},
					selectedTheme.name,
					!!selectedTheme.is_active,
					false,
				)
				: null,
			...Object.entries(currentState.layouts).map(async ([key, item]) => {
				if (
					JSON.stringify(item) !== JSON.stringify(selectedTheme.layouts[key])
				) {
					await updateThemeLayout(
						selectedTheme.id,
						item.id,
						Boolean(item.is_default),
						item.name,
						item,
						false,
					);
				}
			}),
			...Object.entries(currentState.templates).map(async ([key, item]) => {
				if (
					JSON.stringify(item) !== JSON.stringify(selectedTheme.templates[key])
				) {
					await updateThemeTemplate(
						selectedTheme.id,
						item.id,
						item.name,
						Boolean(item.is_default),
						item,
						false,
					);
				}
			}),
		]);

		toastAlert('success', 'Theme was successfully saved');
		clearHistory();
		setIsLoading(false);
	};

	const isVisualEditor = pathname.includes('/visual');

	const close = () => {
		if(isVisualEditor) {
			if(isLoading || currentStateIndex === 0) {
				window.open('https://dashboard.paylix.gg/customization/themes', '_self')
			} else {
				setShowConfirmModal(true);
			}
		} else {
			if((document && document.querySelector('.code-screen-editor-buttons')) || (document && document.querySelector('#tab-notif'))) {
				setShowConfirmModal(true);
			} else {
				window.open('https://dashboard.paylix.gg/customization/themes', '_self')
			}
		}
	};


	return <>
		<ClosePage href="https://dashboard.paylix.gg/customization/themes" open={closeConfirmModal} close={() => setShowConfirmModal(false)} />

		<div className="editor-header">
			<div>
				<div className="editor-header-logo">
					<span style={{ width: "100%", maxWidth: "25rem", overflow: "hidden", color: "var(--black9)", textOverflow: "ellipsis" }}>{(selectedTheme || {}).name}</span>
				</div>

				<div className="editor-header-nav">
					{isVisualEditor && selectedTheme && selectedTheme.templates ?
						<SelectTemplate templates={selectedTheme.templates || null} />
					: null}
					<div className="editor-header-menu">
						{isVisualEditor ? <HistoryButtons /> : null}
						{isVisualEditor ? <a href={`https://${name}.mypaylix.gg`} target="_blank"><Button variant="secondary" size="large" onClick={() => {}}><div className="mr-2"><EyeIcon/></div> Go To Shop</Button></a> : null}
						{isVisualEditor ? isLoading || currentStateIndex === 0 ? null : <Button size="large" disabled={isLoading || currentStateIndex === 0} onClick={handleSave}>{isLoading ? <Spin2 /> : 'Save Changes'}</Button> : null}
						<Button size="large" square variant="secondary" onClick={close}><CloseIcon /></Button>
					</div>
				</div>
			</div>
		</div>
	</>
}


export default Header;
